import Vue from 'vue'
import { relatorio as routing } from '../util/routes'

export default {
  state: {
    variaveis: {},
    relatorio: [],
    openChart: false,
    tableDense: false,
    zeroValue: false
  },
  mutations: {
    setRelatorio: (state, payload) => {
      state.relatorio = payload
    },
    resetVariaveis: state => {
      state.variaveis = {}
    },
    toggleChart: state => {
      state.openChart = !state.openChart
    },
    toggleTable: state => {
      state.tableDense = !state.tableDense
    },
    toggleZeroValue: state => {
      state.zeroValue = !state.zeroValue
    }
  },
  getters: {
    variaveis: ({ variaveis }) => variaveis,
    relatorio: ({ relatorio }) => relatorio,
    openChart: ({ openChart }) => openChart,
    tableDense: ({ tableDense }) => tableDense,
    zeroValue: ({ zeroValue }) => zeroValue
  },
  actions: {
    async getRelatorioRegiaoClienteAtivo (
      { state, commit },
      { estado, regiao = null }
    ) {
      commit('setRelatorio', [])
      const { data } = await Vue.axios.post(`${routing}/regiao/cliente/ativo`, {
        estado,
        regiao
      })
      if (data.length === 0) {
        alert('Nenhum cliente ativo foi encontrado nesta regiao.')
        return Promise.reject(
          new Error('Nenhum cliente ativo foi encontrado nesta regiao.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioRegiaoClienteInativo (
      { state, commit },
      { estado, regiao = null }
    ) {
      commit('setRelatorio', [])
      const { data } = await Vue.axios.post(
        `${routing}/regiao/cliente/inativo`,
        {
          estado,
          regiao
        }
      )
      if (data.length === 0) {
        alert('Nenhum cliente inativo foi encontrado nesta regiao.')
        return Promise.reject(
          new Error('Nenhum cliente inativo foi encontrado nesta regiao.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioRegiaoGeolocalizacao (
      { state, commit },
      { estado, regiao = null }
    ) {
      commit('setRelatorio', [])
      const { data } = await Vue.axios.post(
        `${routing}/regiao/geolocalizacao`, {
          estado,
          regiao
        }
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de clientes foi encontrado nesta região.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de clientes foi encontrado nesta região.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioRegiaoCidade (
      { state, commit },
      { estado, regiao = null }
    ) {
      commit('setRelatorio', [])
      const { data } = await Vue.axios.post(`${routing}/regiao/cidade`, {
        estado,
        regiao
      })
      if (data.length === 0) {
        alert('Nenhuma cidade foi encontrada nesta regiao.')
        return Promise.reject(
          new Error('Nenhuma cidade foi encontrada nesta regiao.')
        )
      }
      console.log(data)
      commit('setRelatorio', data)
    },
    async getRelatorioRegiaoLactacao (
      { state, commit },
      { estado, regiao = null, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        estado,
        regiao,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/regiao/lactacao`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de lactação foi encontrado nesta regiao.')
        return Promise.reject(
          new Error('Nenhum registro de lactação foi encontrado nesta regiao.')
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getTotalByMonth(
          data,
          'visita_data',
          'vacas_total_lactacao',
          false
        )
      )
    },
    async getRelatorioRegiaoValorPagoLeite (
      { state, commit },
      { estado, regiao = null, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        estado,
        regiao,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/regiao/valor/leite`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de valor pago no leite foi encontrado nesta regiao.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de valor pago no leite foi encontrado nesta regiao.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'visita_data',
          'valor_pago_leite',
          true
        )
      )
    },
    async getRelatorioRegiaoProducao (
      { state, commit },
      { estado, regiao = null, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        estado,
        regiao,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/regiao/producao`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de produção foi encontrado nesta regiao.')
        return Promise.reject(
          new Error('Nenhum registro de produção foi encontrado nesta regiao.')
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'visita_data',
          'producao_estimada_mes'
        )
      )
    },
    async getRelatorioCidadeLactacao (
      { state, commit },
      { cidade, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        cidade,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/cidade/lactacao`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de animais em lactação foi encontrado nesta cidade.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de animais em lactação foi encontrado nesta cidade.'
          )
        )
      }

      commit(
        'setRelatorio',
        await Vue.options.filters.getTotalByMonth(
          data,
          'visita_data',
          'vacas_total_lactacao',
          false
        )
      )
    },
    async getRelatorioCidadeGeolocalizacao (
      { state, commit },
      { cidade }
    ) {
      commit('setRelatorio', [])
      let params = {
        cidade
      }
      const { data } = await Vue.axios.post(
        `${routing}/cidade/geolocalizacao`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de clientes foi encontrado nesta cidade.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de clientes foi encontrado nesta cidade.'
          )
        )
      }

      commit('setRelatorio', data)
    },
    async getRelatorioCidadeClienteAtivo ({ state, commit }, { cidade }) {
      commit('setRelatorio', [])
      const { data } = await Vue.axios.post(`${routing}/cidade/cliente/ativo`, {
        cidade
      })
      if (data.length === 0) {
        alert('Nenhum cliente ativo foi encontrado nesta cidade.')
        return Promise.reject(
          new Error('Nenhum cliente ativo foi encontrado nesta cidade.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioCidadeClienteInativo ({ state, commit }, { cidade }) {
      commit('setRelatorio', [])
      const { data } = await Vue.axios.post(
        `${routing}/cidade/cliente/inativo`,
        {
          cidade
        }
      )
      if (data.length === 0) {
        alert('Nenhum cliente inativo foi encontrado nesta cidade.')
        return Promise.reject(
          new Error('Nenhum cliente inativo foi encontrado nesta cidade.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoLactacao (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/lactacao`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de vacas em lactação foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de vacas em lactação foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoProteina (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/proteina`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de proteína foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de proteína foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoGordura (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/gordura`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de gordura foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de gordura foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoLactose (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/lactose`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de lactose foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de lactose foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoSolido (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/solido`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de sólidos foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de sólidos foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoCCS (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/producao/ccs`, params)
      if (data.length === 0) {
        alert('Nenhum registro de CCS foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de CCS foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoCPP (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/producao/cpp`, params)
      if (data.length === 0) {
        alert('Nenhum registro de CPP foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de CPP foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoESD (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/producao/esd`, params)
      if (data.length === 0) {
        alert('Nenhum registro de ESD foi encontrado neste cliente.')
        return Promise.reject(
          new Error('Nenhum registro de ESD foi encontrado neste cliente.')
        )
      }
      commit('setRelatorio', data)
    },
    // async getRelatorioProducaoVolume ({ state, commit }, { cliente, inicial, final }) {
    //   commit('setRelatorio', [])
    //   let params = {
    //     cliente,
    //     inicial,
    //     final
    //   }
    //   const { data } = await Vue.axios.post(`${routing}/producao/volume`, params)
    //   if (data.length === 0) {
    //     alert('Nenhum registro de volume foi encontrado neste cliente.')
    //     return Promise.reject(new Error('Nenhum registro de volume foi encontrado neste cliente.'))
    //   }
    //   commit('setRelatorio', data)
    // },
    async getRelatorioProducaoSeca (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/producao/seca`, params)
      if (data.length === 0) {
        alert(
          'Nenhum registro de vacas no periodo final de lactação foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de vacas no periodo final de lactação foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoMediaLeite (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/media/leite`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de produção de leite foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de produção de leite foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoTotalEstimadaMes (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/total/estimada/mes`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de produção estimada do mês foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de produção estimada do mês foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoValorPagoLeite (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/valor/pago/leite`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de valor pago no leite foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de valor pago no leite foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoCustoAlimentacaoLitro (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/custo/alimentacao/litro`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de custo da alimentação/litro foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de custo da alimentação/litro foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoCustoAlimentacaoConcentradaLactacao (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/custo/alimentacao/concentrada/lactacao`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de custo da alimentação concentrada das vacas em lactação foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de custo da alimentação concentrada das vacas em lactação foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoCustoAlimentacaoVolumosaLactacao (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/custo/alimentacao/volumosa/lactacao`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de custo da alimentação volumosa das vacas em lactação foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de custo da alimentação volumosa das vacas em lactação foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoReceitaEstimadaLeite (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/receita/estimada/leite`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de receita estimada do leite foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de receita estimada do leite foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoDespesaEstimadaAlimentacao (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/despesa/estimada/alimentacao`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de despesa estimada de alimentação foi encontrado neste cliente.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de despesa estimada de alimentação foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioProducaoSobraEstimada (
      { state, commit },
      { cliente, inicial, final }
    ) {
      commit('setRelatorio', [])
      let params = {
        cliente,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/producao/sobra/estimada`,
        params
      )
      if (data.length === 0) {
        alert('Nenhum registro de sobra estimada foi encontrado neste cliente.')
        return Promise.reject(
          new Error(
            'Nenhum registro de sobra estimada foi encontrado neste cliente.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioTecnicoClienteAtendido (
      { state, commit },
      { tecnico, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        tecnico,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/tecnico/cliente/atendido`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de cliente atendido foi encontrado neste técnico.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de cliente atendido foi encontrado neste técnico.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioTecnicoClienteAtendidoBalanceteRequerido (
      { state, commit },
      { tecnico, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        tecnico,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/tecnico/cliente/atendido/balancete-requerido`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de cliente atendido foi encontrado neste técnico.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de cliente atendido foi encontrado neste técnico.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioTecnicoClienteAtendidoBalanceteNaoRequerido (
      { state, commit },
      { tecnico, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        tecnico,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/tecnico/cliente/atendido/balancete-nao-requerido`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de cliente atendido foi encontrado neste técnico.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de cliente atendido foi encontrado neste técnico.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioIndustriaContratoAtivo (
      { state, commit },
      { industria }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/contrato/ativo`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de contrato ativo foi encontrado nesta industria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de contrato ativo foi encontrado nesta industria.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioIndustriaContratoInativo (
      { state, commit },
      { industria }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/contrato/inativo`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de contrato inativo foi encontrado nesta industria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de contrato inativo foi encontrado nesta industria.'
          )
        )
      }
      commit('setRelatorio', data)
    },
    async getRelatorioIndustriaProteina (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/proteina`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de proteína foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de proteína foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_proteina',
          true
        )
      )
    },
    async getRelatorioIndustriaGordura (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/gordura`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de gordura foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de gordura foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_gordura',
          true
        )
      )
    },
    async getRelatorioIndustriaLactose (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/lactose`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de lactose foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de lactose foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_lactose',
          true
        )
      )
    },
    async getRelatorioIndustriaSolido (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/solido`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de sólidos foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de sólidos foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_solido',
          true
        )
      )
    },
    async getRelatorioIndustriaCCS (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/industria/ccs`, params)
      if (data.length === 0) {
        alert(
          'Nenhum registro de CCS foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de CCS foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_ccs',
          true
        )
      )
    },
    async getRelatorioIndustriaCCSWithCPP (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/industria/ccs-cpp`, params)
      if (data.length === 0) {
        alert(
          'Nenhum registro de CCS/CPP foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de CCS/CPP foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getMultipleAvgByMonth(
          data,
          'laudo_data_coleta',
          ['laudo_ccs', 'laudo_cpp'],
          true
        )
      )
    },
    async getRelatorioIndustriaCPP (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/industria/cpp`, params)
      if (data.length === 0) {
        alert(
          'Nenhum registro de CPP foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de CPP foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_cpp',
          true
        )
      )
    },
    async getRelatorioIndustriaESD (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/industria/esd`, params)
      if (data.length === 0) {
        alert(
          'Nenhum registro de ESD foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de ESD foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_esd',
          true
        )
      )
    },
    async getRelatorioIndustriaVolume (
      { state, commit },
      { industria, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        industria,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(
        `${routing}/industria/volume`,
        params
      )
      if (data.length === 0) {
        alert(
          'Nenhum registro de volume foi encontrado em laudos desta indústria.'
        )
        return Promise.reject(
          new Error(
            'Nenhum registro de volume foi encontrado em laudos desta indústria.'
          )
        )
      }
      commit(
        'setRelatorio',
        await Vue.options.filters.getAvgByMonth(
          data,
          'laudo_data_coleta',
          'laudo_volume',
          true
        )
      )
    },
    async getRelatorioContratoEtapas (
      { state, commit },
      { contrato, inicial = null, final = null }
    ) {
      commit('setRelatorio', [])
      let params = {
        contrato,
        inicial,
        final
      }
      const { data } = await Vue.axios.post(`${routing}/contrato/etapa`, params)
      if (data.length === 0) {
        alert('Nenhum registro de laudo foi encontrato neste contrato.')
        return Promise.reject(
          new Error('Nenhum registro de laudo foi encontrato neste contrato.')
        )
      }
      commit('setRelatorio', data)
    }
  }
}
